import { m } from "~/paraglide/messages";

import { Position, type Component } from "../types";
import { Indicator } from "./indicator";

interface AntifreezeProps extends Component {
  defect: boolean;
}

const Antifreeze: React.FC<AntifreezeProps> = ({ defect, position = Position.TOP }) => (
  <Indicator position={position} defect={defect} line="curved" tooltip={m.anti_freeze()}>
    A
  </Indicator>
);

Antifreeze.displayName = "Antifreeze";

export { Antifreeze };
export type { AntifreezeProps };
